export enum LOADING_STATUS {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  NO_CONTENT = 'NOT A 404',
}
